<template lang="pug">
    apexchart.apexchart(height="350" width="98%" type="area" :options="options" :series="series")
</template>

<script>

import Vue from 'vue'

export default {
  name: 'AreaChartDashboard',
  props: {
    series: {
      type: Array,
      default: () => (
        [
          {
            name: 'Cotizaciones',
            data: [0, 0]
          },
          {
            name: 'Ventas',
            data: [0, 0]
          }
        ]
      )
    }
  },
  data () {
    return {
      options: {
        stroke: {
          curve: 'smooth'
        },
        chart: {
          id: 'area-chart-dashboard',
          type: 'area'
        },
        dataLabels: {
          enabled: false
        },
        markers: {
          size: 0,
          style: 'hollow'
        },
        tooltip: {
          x: {
            format: 'dd MMM yyyy'
          },
          y: {
            formatter: val => {
              return Vue.filter('currency')(val)
            }
          }
        },
        colors: ['#ff7b00', '#28c868'],
        fill: {
          type: 'gradient',
          gradient: {
            shadeIntensity: 1,
            opacityFrom: 0.5,
            opacityTo: 1,
            stops: [0, 100]
          }
        }
      }
    }
  }
}
</script>
